import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from '@app/store';
import { getCrematoryFeaturesActionCreators } from '@app/store/CrematoryFeatures';

export function useCrematoryFeatures() {
	const dispatch = useDispatch();
	const crematoryFeaturesStore = useSelector((state: ApplicationState) => state.crematoryFeatures);

	React.useEffect(() => {
		if (crematoryFeaturesStore.item) return;
		if (crematoryFeaturesStore.isLoading) return;

		const factory = getCrematoryFeaturesActionCreators();
		dispatch(factory.request());
	}, [crematoryFeaturesStore.item, dispatch]);

	return crematoryFeaturesStore;
}
